import { render, staticRenderFns } from "./GoodsSliderImageSelector.vue?vue&type=template&id=ec3dec88&scoped=true"
import script from "./GoodsSliderImageSelector.vue?vue&type=script&lang=js"
export * from "./GoodsSliderImageSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec3dec88",
  null
  
)

export default component.exports